import axios from 'axios';

const instance = axios.create({
  baseURL: `https://webdist.data.apnic.net/lists/theme-v1.json`
});

export default instance;
